import { dmApi } from "../../app/dmApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../helpers/RtkQueryUtils";
import { serialize } from "../../helpers/Utils";
import BrokerageOverview from "./components/BrokerageOverview";

export const dashBoardApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        searchPieChartData: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/receiving-data/pie-chart-data?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['pieChart'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        searchBarChartData: build.query({
            query: (data) => {
                let paramData = serialize(data);

                return {
                    url: `/receiving-data/bar-chart-data?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['barChart'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        createEmployeeData: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/receiving-data/employees-data/store`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['employeeReceiving'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Employee Data")
            },

        }),


        //  Dashboard Api's 

        getBiggestDaily: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/dashboard/biggest-daily?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            invalidatesTags: ['biggestDailyData'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        // Fresh Fruit Running Total 

        getFreshFruitRunningTotal: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/dashboard/fresh-fruit-running-total?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['freshFruitRunningTotalQuery'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        // Season Duration
        getSeason: build.query({
            query: () => ({
                url: `/dashboard/get-season-duration`,
                method: 'GET',
                headers: getAuthorizationHeader(),
            }),
            providesTags: ['seasonDuration'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),


        //  ############## Overall Analytics ##################

        //  Receving Overview

        getReceivingDataAnalytics: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/dashboard/receiving-data-analytics?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                }
            },
            providesTags: ['receivingDataAnalytics'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        // Cold-storage & Ripening

        getColdStorageAndRipening: build.query({
            query: () => ({
                url: `/dashboard/coldstorage-and-ripening-data`,
                method: 'GET',
                headers: getAuthorizationHeader(),
            }),
            providesTags: ['coldStorageAndRipeningQuery'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        saveSeason: build.mutation({
            query: (requestBody) => ({
                url: `/dashboard/set-season-duration`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['seasonDuration' ,'freshFruitRunningTotalQuery'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Saved", "Season");
            },
        }),


        
        //  ############ Processing Analytics ############

        getProcessingAnalytics : build.query({
            query : (data) => {
                let paramData = serialize(data);
                return {
                    url: `/dashboard/processing-analytics?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(), 
                }
            },
            providesTags:['processingAnalytics'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        //  ############ Packing Analytics ############

        getPackingAnalytics : build.query({
            query : (data) => {
                let paramData = serialize(data);
                return {
                    url: `/dashboard/packing-analytics?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(), 
                }
            },
            providesTags:['packingAnalytics'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        // ############ Brokerage Analytics ############

        getBrokerageAnalytics : build.query({
            query : (data) => {
                let paramData = serialize(data);
                return {
                    url: `/dashboard/brokerage-data-analytics?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(), 
                }
            },
            providesTags:['brokerageOverviewAnalytics'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        })
    }),

});

export const {
    useSearchPieChartDataQuery,
    useSearchBarChartDataQuery,
    useCreateEmployeeDataMutation,
    useGetBiggestDailyQuery,
    useGetFreshFruitRunningTotalQuery,
    useGetSeasonQuery,
    useSaveSeasonMutation,
    useGetReceivingDataAnalyticsQuery,
    useGetColdStorageAndRipeningQuery,
    useGetPackingAnalyticsQuery,
    useGetProcessingAnalyticsQuery,
    useGetBrokerageAnalyticsQuery,
} = dashBoardApi;

